// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'omit' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { omit } from "lodash";

import MailboxSerializer from "services/api/mailboxes/MailboxSerializer";
import { IMailbox } from "store/entities/mailboxes/interfaces";

import BaseApi from "../base/base-api";

export default class MailboxesApi extends BaseApi {
  protected readonly prefix = "mailboxes";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (mailbox: Partial<IMailbox>) => this.post("", MailboxSerializer.serialize(mailbox));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (mailbox: Partial<IMailbox>) => this.patch(mailbox.id, MailboxSerializer.serialize(mailbox));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteMailbox = (mailboxId: string) => this.delete(mailboxId);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchNextAddress = () => this.get("nextName");

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (mailboxId: string) => this.get(mailboxId);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
}
